export default __webpack_public_path__ + "static/media/Tushar.fa6d94cb.jpg";